import React, { useState, createRef, RefObject, useEffect } from 'react';

import { Props } from './interfaces';
import './DropdownList.scss';
import { AnchorLink } from 'react-anchor-navigation';
import {Link} from "../../Link/Link";

const DropdownList = ({ title, list, closed, dopContent }: Props) => {
  const [toggle, setToggle] = useState(false);
  const ToggleList = () => {
    setToggle(!toggle);
    !toggle ? Show() : Closed();
  };

  const [height, setHeight] = useState(0);
  useEffect(() => {
    const heightTexts = list.flat().length * 20;
    const heightGapParts = list.length * 24;
    const heightGapInList = (list.flat().length - list.length) * 12;
    const heightDopContent = dopContent ? 56 : 0; // высота кнопки S(40) + gap(16)

    setHeight(heightTexts + heightGapParts + heightGapInList + heightDopContent);
  }, [list]);

  const refContent: RefObject<HTMLDivElement> = createRef();
  const settingsAnimation: KeyframeAnimationOptions = { fill: 'forwards', duration: 500 };
  const Show = () => {
    refContent.current?.animate(
      [{ height: 0 }, { height: `${height}px` }, { height: 'auto' }],
      settingsAnimation
    );
  };
  const Closed = () => {
    refContent.current?.animate(
      [{ height: 'auto' }, { height: `${height}px` }, { height: 0 }],
      settingsAnimation
    );
  };

  return (
    <div className={`dropdown-list${toggle ? ' dropdown-list_show' : ''}`}>
      <h4 className="dropdown-list__title" onClick={ToggleList}>
        {title}
      </h4>

      <div ref={refContent} className={`dropdown-list__content`}>
        {list.map((item, i) => (
          <div className="dropdown-list__list" key={i}>
            {item.map(({ title, url }, idx) =>
              (
                <Link to={url} key={idx} onClick={closed}>
                  <p className="body2" dangerouslySetInnerHTML={{ __html: title }}></p>
                </Link>
              )
            )}
          </div>
        ))}

        {dopContent}
      </div>
    </div>
  );
};

export default DropdownList;
